import { SVGProps } from 'react';

export default function ParkingSignIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" {...props}>
      <circle cx="15" cy="15" r="12" fill="#3F454D" />
      <path
        d="M14.9954 22.7542C19.2801 22.7542 22.7576 19.2847 22.7576 15C22.7576 10.7153 19.2801 7.24583 14.9954 7.24583C10.7188 7.24583 7.24121 10.7153 7.24121 15C7.24121 19.2847 10.7188 22.7542 14.9954 22.7542ZM14.9954 21.4662C11.4208 21.4662 8.53562 18.5745 8.53562 15C8.53562 11.4255 11.4208 8.53382 14.9954 8.53382C18.5699 8.53382 21.4616 11.4255 21.4616 15C21.4616 18.5745 18.5699 21.4662 14.9954 21.4662ZM13.355 18.4795C13.7537 18.4795 13.9764 18.2228 13.9764 17.8016V16.1359H15.4694C16.9566 16.1359 17.9479 15.2092 17.9479 13.8025C17.9479 12.412 16.9469 11.4611 15.4774 11.4611H13.3517C12.9628 11.4611 12.7577 11.7403 12.7577 12.147V17.8016C12.7577 18.2067 12.966 18.4795 13.355 18.4795ZM13.9764 15.2091V12.3943H15.3033C16.1948 12.3943 16.7533 12.9319 16.7533 13.8025C16.7533 14.6715 16.1996 15.2091 15.3033 15.2091H13.9764Z"
        fill="white"
      />
    </svg>
  );
}
